import React from 'react';
import { FadeIn } from './animations/MotionPrimitives';
import SectionCourier from './illustrations/SectionCourier';
import TapeStrip from './illustrations/TapeStrip';
import SubtypeExperiment from './illustrations/SubtypeExperiment';
import './styles/Research.css';

const DATASETS = ['CIFAR-10', 'CIFAR-100', 'iNaturalist 2021 Mini (iNat2021 Mini)'];

const DESIGN = [
  'Seen and unseen subtype splits',
  'Five rotated subtype splits',
  'Fixed training-image budgets',
  'Multiple subtype-coverage conditions',
  'Top-1 and Top-5 evaluation',
  'Broader-category and subtype-level performance analysis',
];

function Research() {
  return (
    <section className="section research" id="research">
      <div className="section-inner research-inner">
        <FadeIn className="chapter-head research-head">
          <span className="chapter-mark">04</span>
          <h2 className="chapter-title">Subtype Generalization Research</h2>
        </FadeIn>

        <FadeIn className="research-journal" delay={0.05}>
          <div className="research-main">
            <span className="research-affiliation">Illinois Institute of Technology</span>

            <article className="research-note research-note--question">
              <span className="research-note-label">Research question</span>
              <p className="research-question">
                How does subtype coverage affect a model’s ability to classify an unseen
                subtype into the correct broader category?
              </p>
            </article>

            <article className="research-note">
              <span className="research-note-label">Datasets</span>
              <div className="research-datasets">
                {DATASETS.map((dataset) => (
                  <span className="research-dataset" key={dataset}>
                    {dataset}
                  </span>
                ))}
              </div>
            </article>

            <article className="research-note">
              <span className="research-note-label">Experiment design</span>
              <ul className="research-design">
                {DESIGN.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </article>

            <article className="research-note research-note--status">
              <span className="research-note-label">Current status</span>
              <p>
                Core experiments are nearly complete. Current work focuses on code cleanup,
                reproducibility, documentation and preparing the final research handoff.
              </p>
            </article>
          </div>

          <aside className="research-figure">
            <TapeStrip className="research-figure-tape" tone="blue" />
            <span className="research-figure-label">Subtype Coverage Experiment</span>
            <div className="research-figure-slot">
              <SubtypeExperiment className="research-figure-svg" />
            </div>
            <p className="research-figure-text">
              How a broader range of seen subtypes may help the model place a held-out
              subtype in the correct broader category.
            </p>
            <SectionCourier
              className="research-courier"
              carry="ticket"
              width={62}
              from={{ x: 16, y: 12, rotate: 12 }}
              restRotate={6}
            />
          </aside>
        </FadeIn>
      </div>
    </section>
  );
}

export default Research;
